import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-n-small', 'LetterNSmall', [["path",{"d":"M10 16v-8l4 8v-8"}]]);